let anchorAttrName = "data-goto-anchor";

export function scrollTo(position, callback) {
    let duration = arguments.length <= 2 || arguments[2] === undefined ? 400 : arguments[2];

    $("body, html").animate({scrollTop: position}, duration, function () {
        if (callback) {
            callback();
        }
    });
}

export function scrollToRecursion(target) {
    //var duration = arguments.length <= 1 || arguments[1] === undefined ? 200 : arguments[1];

    let getPosition = function getPosition() {
        let header = $(".main-header");
        let correctionPosition = 0;
        let parentHeight = $(".quick-links");

        if (header.length) {
            correctionPosition = parseInt(header.outerHeight()) + parseInt(parentHeight.outerHeight()) + 20;
        }
        
        return parseInt(target.offset().top) - correctionPosition;
    };
    let position = getPosition();
    scrollTo(position, function () {
        let newPosition = getPosition();
        /*an extra scroll cycle (starting an additional iteration recursion) is made specifically to make allowances for lazy loading blocks*/
        if (position != newPosition) {
            
            scrollToRecursion(target);
        }
    });
}

export function goToAnchor() {
    let anchorSection = $("[data-anchor]");
    let header = $(".header");
    let anchorList = $(".quick-links");
    let topPosition = header.outerHeight() + anchorList.outerHeight();
    let activeSection;
    let isClick = false;

    $("body").on("click", "[" + anchorAttrName + "]", function (e) {
        e.preventDefault();

        let totalWidth = 0;
        let _this = $(this);
        let tabIndex = _this.parent().index();
        const parent = _this.closest("ul");
        $(parent).find(".current-menu-item").removeClass("current-menu-item");

        if(!parent.hasClass("subnavigation")) {
            _this.addClass("current-menu-item");
        } else {
            _this.parent().addClass("current-menu-item");
            isClick = true;
        }
        for (let i = 0; i < tabIndex; i++) {
            totalWidth += parent.find('li').eq(i).innerWidth();
        }
        parent.animate({ scrollLeft: totalWidth }, 500);

        scrollToRecursion($("[data-anchor=" + _this.attr(anchorAttrName) + "] .container"), 400);
    });

    $(window).on("scroll", function (e) {
        let winTop = $(window).scrollTop();

        anchorSection.each((index, el) => {
            let itemTop = $(el).offset().top;
            if( itemTop - topPosition <= winTop && itemTop + $(el).outerHeight() >= $(window).outerHeight()) {
                activeSection = $(el).data("anchor");
            }
        });

        let anchorBtn = $(`[data-goto-anchor = ${activeSection}]`)
        let anchorParent = anchorBtn.parent();

        if (!anchorParent.hasClass("current-menu-item")) {
            anchorParent.siblings().removeClass("current-menu-item");
            anchorParent.addClass("current-menu-item");

            if(!isClick && anchorParent.length) {
                const offsetLeft = anchorList.find(".subnavigation").scrollLeft() + anchorParent.position().left;
                anchorList.find(".subnavigation").animate({
                    scrollLeft: offsetLeft
                }, 500);
    
                isClick = false;
            }
        }
    });

    $(window).on("resize", function (){
        topPosition = header.outerHeight() + anchorList.outerHeight();
    });
}




// WEBPACK FOOTER //
// ./assets/js/modules/goToAnchor.js